module.exports = {
      id: "ic-300-1s-index-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#ic-300-1s-index-usage",
      toString: function () {
        return this.url;
      }
    }